import _ from 'lodash';
import { API_SCHEDULE_FINAL_STATUSES, API_SERVICE_TYPES } from '@/constants';

const isActiveServiceSchedule = ({ schedule }) =>
  !API_SCHEDULE_FINAL_STATUSES.includes(schedule.status);

const isServiceMowing = (schedule) => {
  return (
    _.get(lsScheduleHelpers.getServiceFromSchedule(schedule), 'str_id') === API_SERVICE_TYPES.MOWING
  );
};

const getServiceFromSchedule = (schedule) => {
  return (
    _.get(schedule, 'service') ||
    _.get(schedule, 'instant_quote.instant_quote_bush_trimming.service') ||
    _.get(schedule, 'instant_quote.instant_quote_flower_bed_weeding.service') ||
    _.get(schedule, 'instant_quote.instant_quote_leaf_removal.service') ||
    _.get(schedule, 'manualquote.service') ||
    _.get(schedule, 'qualityassurance.service')
  );
};

const findActiveScheduleByServiceId = ({ schedules, serviceId }) =>
  schedules.find(
    (schedule) =>
      lsScheduleHelpers.isActiveServiceSchedule({ schedule }) &&
      _.get(lsScheduleHelpers.getServiceFromSchedule(schedule), 'id') === serviceId
  );

export const lsScheduleHelpers = {
  isActiveServiceSchedule,
  isServiceMowing,
  getServiceFromSchedule,
  findActiveScheduleByServiceId,
};
